export enum MatchTeamSeasonOutcome {
  Win = 'win',
  Draw = 'draw',
  Loss = 'loss'
}
